import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t,
    language,
    getSlug
  } = useLanguage();
  const currentYear = new Date().getFullYear();
  const getLanguageLink = (slug: string) => {
    const localizedSlug = getSlug(slug);
    return `/${language}/${localizedSlug}`;
  };
  return <footer className="bg-[#2B2B2B] text-white pt-16 pb-8" data-id="element-96">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-98">
          {/* Company Info */}
          <div className="space-y-6" data-id="element-99">
            <Link to={`/${language}`} className="inline-block" data-id="element-100">
              <img src="https://cdn.magicpatterns.com/uploads/sSNAfpvwR9DMLUnYLkRqa2/logo-GRG-Graha-Riau-Gemilang.png" alt="PT Graha Riau Gemilang" className="h-12 w-auto brightness-0 invert opacity-90 hover:opacity-100 transition-opacity" data-id="element-101" />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-102">
              {t('Developer properti terpercaya di Riau sejak 2005. Membangun hunian berkualitas dan komunitas yang harmonis untuk masa depan yang lebih baik.', 'Trusted real estate developer in Riau since 2005. Building quality homes and harmonious communities for a better future.')}
            </p>
            <div className="bg-white/5 border border-white/10 rounded-lg p-3" data-id="element-103">
              <p className="text-xs text-gray-400 mb-1" data-id="element-104">
                {t('Anggota Resmi REI', 'Official REI Member')}
              </p>
              <p className="text-sm text-white font-semibold" data-id="element-105">
                {t('No. Registrasi: 03.00174', 'Registration No: 03.00174')}
              </p>
            </div>
            <div className="flex space-x-4" data-id="element-106">
              <a href="https://www.instagram.com/pt.grahariaugemilang/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#C4161C] transition-colors" data-id="element-107">
                <Instagram className="w-5 h-5" data-id="element-108" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C4161C] transition-colors" data-id="element-109">
                <Facebook className="w-5 h-5" data-id="element-110" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C4161C] transition-colors" data-id="element-111">
                <Linkedin className="w-5 h-5" data-id="element-112" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-113">
            <h3 className="text-lg font-bold mb-6 border-b border-gray-700 pb-2 inline-block" data-id="element-114">
              {t('Menu Utama', 'Main Menu')}
            </h3>
            <ul className="space-y-3" data-id="element-115">
              {[{
              name: t('Tentang Kami', 'About Us'),
              slug: 'tentang-kami'
            }, {
              name: t('Manajemen', 'Management'),
              slug: 'manajemen'
            }, {
              name: t('Proyek', 'Projects'),
              slug: 'proyek'
            }, {
              name: t('Produk & Layanan', 'Products & Services'),
              slug: 'produk-layanan'
            }, {
              name: t('Kontak', 'Contact'),
              slug: 'kontak'
            }].map(item => <li key={item.slug} data-id="element-116">
                  <Link to={getLanguageLink(item.slug)} className="text-gray-400 hover:text-[#C4161C] transition-colors text-sm" data-id="element-117">
                    {item.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Products */}
          <div data-id="element-118">
            <h3 className="text-lg font-bold mb-6 border-b border-gray-700 pb-2 inline-block" data-id="element-119">
              {t('Produk Kami', 'Our Products')}
            </h3>
            <ul className="space-y-3" data-id="element-120">
              {[t('Rumah Subsidi', 'Subsidized Housing'), t('Rumah Premium', 'Premium Residences'), t('Ruko & Kios', 'Shop Houses & Kiosks'), t('Properti Komersial', 'Commercial Properties'), t('Konsultasi Properti', 'Property Consultation')].map((item, index) => <li key={index} data-id="element-121">
                  <Link to={getLanguageLink('produk-layanan')} className="text-gray-400 hover:text-[#C4161C] transition-colors text-sm" data-id="element-122">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-123">
            <h3 className="text-lg font-bold mb-6 border-b border-gray-700 pb-2 inline-block" data-id="element-124">
              {t('Hubungi Kami', 'Contact Us')}
            </h3>
            <ul className="space-y-4" data-id="element-125">
              <li className="flex items-start space-x-3" data-id="element-126">
                <MapPin className="w-5 h-5 text-[#C4161C] flex-shrink-0 mt-0.5" data-id="element-127" />
                <span className="text-gray-400 text-sm" data-id="element-128">
                  Jl. Tiung No. 16A, Kel. Kampung Melayu,
                  <br data-id="element-129" />
                  Kec. Sukajadi, Pekanbaru, Riau
                </span>
              </li>
              <li className="flex flex-col space-y-2" data-id="element-130">
                <div className="flex items-center space-x-3" data-id="element-131">
                  <Phone className="w-5 h-5 text-[#C4161C] flex-shrink-0" data-id="element-132" />
                  <div className="flex flex-col space-y-1" data-id="element-133">
                    <a href="tel:+6276121493" className="text-gray-400 text-sm hover:text-[#C4161C] transition-colors" data-id="element-134">
                      0761-21493
                    </a>
                    <a href="tel:+6276147961" className="text-gray-400 text-sm hover:text-[#C4161C] transition-colors" data-id="element-135">
                      0761-47961
                    </a>
                  </div>
                </div>
              </li>
              <li className="flex flex-col space-y-2" data-id="element-136">
                <div className="flex items-start space-x-3" data-id="element-137">
                  <svg className="w-5 h-5 text-[#25D366] flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 24 24" data-id="element-138">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-139" />
                  </svg>
                  <div className="flex flex-col space-y-1" data-id="element-140">
                    <a href="https://wa.me/62817203456" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-[#25D366] transition-colors" data-id="element-141">
                      +62 817-203-456
                    </a>
                    <a href="https://wa.me/6281365631901" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-[#25D366] transition-colors" data-id="element-142">
                      +62 813-6563-1901
                    </a>
                  </div>
                </div>
              </li>
              <li className="flex items-center space-x-3" data-id="element-143">
                <Mail className="w-5 h-5 text-[#C4161C] flex-shrink-0" data-id="element-144" />
                <a href="mailto:grahariaugemilang@gmail.com" className="text-gray-400 text-sm hover:text-[#C4161C] transition-colors" data-id="element-145">
                  grahariaugemilang@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-146">
          <p className="text-gray-500 text-sm text-center md:text-left mb-4 md:mb-0" data-id="element-147">
            &copy; {currentYear} PT Graha Riau Gemilang.{' '}
            {t('Hak Cipta Dilindungi.', 'All rights reserved.')}
          </p>
          <div className="flex space-x-6 text-sm text-gray-500" data-id="element-148">
            <Link to="#" className="hover:text-white transition-colors" data-id="element-149">
              {t('Kebijakan Privasi', 'Privacy Policy')}
            </Link>
            <Link to="#" className="hover:text-white transition-colors" data-id="element-150">
              {t('Syarat Layanan', 'Terms of Service')}
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}